import { createStyles, makeStyles } from '@material-ui/styles';
import { FlatIconProps } from './index';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& svg path': {
        stroke: (props: Partial<FlatIconProps>) =>
          props.color || palette.text.primary
      }
    },
    small: {
      height: '16px',
      width: '16px'
    },
    normal: {
      height: '24px',
      width: '24px'
    },
    large: {
      height: '33px',
      width: '33px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
